/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AnalyticsBaseService } from '../analytics-base-service';
import { AnalyticsApiConfiguration } from '../analytics-api-configuration';
import { AnalyticsStrictHttpResponse } from '../analytics-strict-http-response';

import { productionAnalysisControllerDeleteByProjectAndTenant } from '../fn/production-analysis/production-analysis-controller-delete-by-project-and-tenant';
import { ProductionAnalysisControllerDeleteByProjectAndTenant$Params } from '../fn/production-analysis/production-analysis-controller-delete-by-project-and-tenant';
import { productionAnalysisControllerFindByProjectAndTenant } from '../fn/production-analysis/production-analysis-controller-find-by-project-and-tenant';
import { ProductionAnalysisControllerFindByProjectAndTenant$Params } from '../fn/production-analysis/production-analysis-controller-find-by-project-and-tenant';
import { productionAnalysisControllerFindByTenant } from '../fn/production-analysis/production-analysis-controller-find-by-tenant';
import { ProductionAnalysisControllerFindByTenant$Params } from '../fn/production-analysis/production-analysis-controller-find-by-tenant';
import { AnalyticsProductionAnalysisResponseDto } from '../models/analytics-production-analysis-response-dto';

@Injectable({ providedIn: 'root' })
export class AnalyticsProductionAnalysisService extends AnalyticsBaseService {
  constructor(config: AnalyticsApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `productionAnalysisControllerFindByTenant()` */
  static readonly ProductionAnalysisControllerFindByTenantPath = '/o2-analytics/production-analysis/{tenant}';

  /**
   * Get all production analyses for a tenant.
   *
   * Returns all production analyses for a tenant with cost breakdowns (internal and external costs per task and project).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productionAnalysisControllerFindByTenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  productionAnalysisControllerFindByTenant$Response(params: ProductionAnalysisControllerFindByTenant$Params, context?: HttpContext): Observable<AnalyticsStrictHttpResponse<Array<AnalyticsProductionAnalysisResponseDto>>> {
    const obs = productionAnalysisControllerFindByTenant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all production analyses for a tenant.
   *
   * Returns all production analyses for a tenant with cost breakdowns (internal and external costs per task and project).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productionAnalysisControllerFindByTenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productionAnalysisControllerFindByTenant(params: ProductionAnalysisControllerFindByTenant$Params, context?: HttpContext): Observable<Array<AnalyticsProductionAnalysisResponseDto>> {
    const resp = this.productionAnalysisControllerFindByTenant$Response(params, context);
    return resp.pipe(
      map((r: AnalyticsStrictHttpResponse<Array<AnalyticsProductionAnalysisResponseDto>>): Array<AnalyticsProductionAnalysisResponseDto> => r.body)
    );
  }

  /** Path part for operation `productionAnalysisControllerFindByProjectAndTenant()` */
  static readonly ProductionAnalysisControllerFindByProjectAndTenantPath = '/o2-analytics/production-analysis/{tenant}/project/{projectId}';

  /**
   * Get production analysis for a specific project.
   *
   * Returns production analysis for a specific project with cost breakdowns (internal and external costs per task and project).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productionAnalysisControllerFindByProjectAndTenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  productionAnalysisControllerFindByProjectAndTenant$Response(params: ProductionAnalysisControllerFindByProjectAndTenant$Params, context?: HttpContext): Observable<AnalyticsStrictHttpResponse<AnalyticsProductionAnalysisResponseDto>> {
    const obs = productionAnalysisControllerFindByProjectAndTenant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get production analysis for a specific project.
   *
   * Returns production analysis for a specific project with cost breakdowns (internal and external costs per task and project).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productionAnalysisControllerFindByProjectAndTenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productionAnalysisControllerFindByProjectAndTenant(params: ProductionAnalysisControllerFindByProjectAndTenant$Params, context?: HttpContext): Observable<AnalyticsProductionAnalysisResponseDto> {
    const resp = this.productionAnalysisControllerFindByProjectAndTenant$Response(params, context);
    return resp.pipe(
      map((r: AnalyticsStrictHttpResponse<AnalyticsProductionAnalysisResponseDto>): AnalyticsProductionAnalysisResponseDto => r.body)
    );
  }

  /** Path part for operation `productionAnalysisControllerDeleteByProjectAndTenant()` */
  static readonly ProductionAnalysisControllerDeleteByProjectAndTenantPath = '/o2-analytics/production-analysis/{tenant}/project/{projectId}';

  /**
   * Delete production analysis by project ID.
   *
   * Deletes a production analysis for a specific project. Only production analyses with status DELETED can be deleted.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productionAnalysisControllerDeleteByProjectAndTenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  productionAnalysisControllerDeleteByProjectAndTenant$Response(params: ProductionAnalysisControllerDeleteByProjectAndTenant$Params, context?: HttpContext): Observable<AnalyticsStrictHttpResponse<AnalyticsProductionAnalysisResponseDto>> {
    const obs = productionAnalysisControllerDeleteByProjectAndTenant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete production analysis by project ID.
   *
   * Deletes a production analysis for a specific project. Only production analyses with status DELETED can be deleted.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productionAnalysisControllerDeleteByProjectAndTenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productionAnalysisControllerDeleteByProjectAndTenant(params: ProductionAnalysisControllerDeleteByProjectAndTenant$Params, context?: HttpContext): Observable<AnalyticsProductionAnalysisResponseDto> {
    const resp = this.productionAnalysisControllerDeleteByProjectAndTenant$Response(params, context);
    return resp.pipe(
      map((r: AnalyticsStrictHttpResponse<AnalyticsProductionAnalysisResponseDto>): AnalyticsProductionAnalysisResponseDto => r.body)
    );
  }

}
